export default __webpack_public_path__ + "static/Logo-Lightning-557a63cb5057232b170ebb51ff857bcc.png";